// Rounds the value up or down to the nearest multiple of n, for example:
// roundToNearestN(6432, 100) => 6400
// roundToNearestN(0.365, 0.1) => 0.4  
export default function roundToNearestN(value, n) {
    return Math.round(value / n) * n
}